import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutAlignTopBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutAlignTopBottom"><Path d="M3.5 3.5L20.5 3.5V20.5H3.5L3.5 3.5Z" stroke="currentColor"/><Path d="M7 7.5H17" stroke="currentColor"/><Path d="M7 16.5H17" stroke="currentColor"/></CentralIconBase>;
});

export default IconLayoutAlignTopBottom;
